import { TAGS, api } from "store/api"
import {
  IArenaCycleLeaderboardResponse,
  IArenaCycleRewardStep,
  IArenaCycleState,
  IArenaCyclePendingReward,
  IArenaCyclesCount
} from "./bossArenaCycle.types"

export const bossArenaCycleAPI = api.enhanceEndpoints({
  addTagTypes: [
    TAGS.BOSS_ARENA_CYCLE_LB,
    TAGS.BOSS_ARENA_CYCLE_REWARDS,
    TAGS.BOSS_ARENA_CYCLE_STATE,
    TAGS.BOSS_ARENA_CYCLE_PENDING
  ]
})

export const bossArenaCycleEndpoints = bossArenaCycleAPI.injectEndpoints({
  endpoints: (builder) => ({
    getArenaCycleLeaderboard: builder.query<
      IArenaCycleLeaderboardResponse,
      { league?: number; page: number; limit: number; cycleId?: number }
    >({
      query: ({ league, page, limit, cycleId }) => ({
        url: `/boss/arena-cycle/leaderboard`,
        method: "GET",
        params: {
          page,
          limit,
          ...(league !== undefined && { league }),
          ...(cycleId !== undefined && { cycleId })
        }
      }),
      providesTags: (_, __, params) => [
        { type: TAGS.BOSS_ARENA_CYCLE_LB, id: "LIST" },
        {
          type: TAGS.BOSS_ARENA_CYCLE_LB,
          id: `LB:league:${params.league ?? "default"}:cycle:${params.cycleId ?? "current"}:page:${params.page}:limit:${params.limit}`
        }
      ]
    }),
    getArenaCyclesCount: builder.query<IArenaCyclesCount, void>({
      query: () => ({
        url: `/boss/arena-cycle/cycles-count`,
        method: "GET"
      }),
      providesTags: [{ type: TAGS.BOSS_ARENA_CYCLE_LB, id: "CYCLES_COUNT" }]
    }),
    getArenaCycleRewards: builder.query<
      IArenaCycleRewardStep[],
      { league?: number }
    >({
      query: ({ league }) => ({
        url: `/boss/arena-cycle/rewards`,
        method: "GET",
        params: {
          ...(league !== undefined && { league })
        }
      }),
      providesTags: (_, __, params) => [
        { type: TAGS.BOSS_ARENA_CYCLE_REWARDS, id: "LIST" },
        {
          type: TAGS.BOSS_ARENA_CYCLE_REWARDS,
          id: `REWARDS:league:${params.league ?? "default"}`
        }
      ]
    }),
    getArenaCycleState: builder.query<IArenaCycleState, void>({
      query: () => ({
        url: `/boss/arena-cycle/state`,
        method: "GET"
      }),
      providesTags: [{ type: TAGS.BOSS_ARENA_CYCLE_STATE, id: "CURRENT" }]
    }),
    getArenaCyclePendingReward: builder.query<
      IArenaCyclePendingReward | null,
      void
    >({
      query: () => ({
        url: `/boss/arena-cycle/pending-reward`,
        method: "GET"
      }),
      providesTags: [{ type: TAGS.BOSS_ARENA_CYCLE_PENDING, id: "CURRENT" }]
    }),
    markArenaCyclePendingRewardSeen: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/boss/arena-cycle/pending-reward/${id}/seen`,
        method: "POST"
      }),
      invalidatesTags: [
        { type: TAGS.BOSS_ARENA_CYCLE_PENDING, id: "CURRENT" },
        { type: TAGS.BOSS_ARENA_CYCLE_LB, id: "LIST" },
        { type: TAGS.BOSS_ARENA_CYCLE_STATE, id: "CURRENT" }
      ]
    })
  })
})

export const {
  useGetArenaCycleLeaderboardQuery,
  useGetArenaCyclesCountQuery,
  useGetArenaCycleRewardsQuery,
  useGetArenaCycleStateQuery,
  useGetArenaCyclePendingRewardQuery,
  useMarkArenaCyclePendingRewardSeenMutation
} = bossArenaCycleEndpoints
